<mat-card>
    <mat-card-header class="name">
      <span>{{pt.name}}</span>
    </mat-card-header>
    <mat-card-content>
      <div class="description">{{pt.description}}</div>
      <div class="features"><ng-image-slider #slider [images]="images" [imageSize]="imageSize" /></div>
    </mat-card-content>
</mat-card>
